import Vue from "vue";

import HowItWorksMiniCard from "./components/how-it-works-mini-card/how-it-works-mini-card.vue";

// mixins
import { comingSoonMixins } from '@/app/mixins/utils/coming-soon-mixins';

// constants
const { VUE_APP_STORE_CREDIT } = process.env;

export default {
    name: "LandingPageHowItWorks",
    data() {
        return {
            inputFields: {
                puppyPrice: "",
            },
            packagePrice: parseInt(VUE_APP_STORE_CREDIT.replaceAll(",", "")),
            storeCredit: VUE_APP_STORE_CREDIT,
            perWeekPrice: 0,
        };
    },
    components: {
        HowItWorksMiniCard,
    },
    mixins: [
        comingSoonMixins
    ],
    methods: {
        showComingSoonModal(){
            this.showHomeComingSoonAlert();
        },
        onSelectPackage(id, index, isMonthly) {
            const packs = isMonthly ? this.monthlyPackages : this.packages;
            Vue.set(
                isMonthly ? this.selectedMonthlyPackages : this.selectedWelcomePackages,
                index,
                packs.find((x) => x.id == id)
            );
        },
        generateDropdownOptions(isMonthly) {
            let options = [];
            for (const pack of isMonthly ? this.monthlyPackages : this.packages) {
                options.push({
                    value: pack.id,
                    option: pack.title,
                });
            }
            return options;
        },
        calculateRepayments() {
            if (this.inputFields.puppyPrice === "" || !this.inputFields.puppyPrice) {
                //- No space for validation errors in mockup/designs provided
                // this.inputFields.puppyPrice = "$3,500.00";
            }

            const inputtedPrice = (this.inputFields.puppyPrice && this.inputFields.puppyPrice.trim()) ? this.inputFields.puppyPrice : 0;

            const puppyPrice = inputtedPrice ? parseFloat(this.clearFormatting(inputtedPrice)) : 0;
            const packagePrice = this.packagePrice;
            this.perWeekPrice = parseInt((puppyPrice + packagePrice) / 24);

            const element = document.getElementById("scrollId");

            if (window.innerWidth <= 768) {
                element.scrollIntoView({ behavior: "smooth" });
            }

        },
        formatCurrency(value) {
            if (value !== "") {
                let val = (parseFloat(value) / 1).toFixed(2);
                return `$${val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
            } else {
                return null;
            }
        },
        clearFormatting(value) {
            value = value.replace(",", "");
            value = value.replace("$", "");
            return value;
        },
        formatCurrencyInput() {
            let amount = this.clearFormatting(this.inputFields.puppyPrice);
            this.inputFields.puppyPrice = this.formatCurrency(amount);
        },
        blockCurrencyInput(e) {
            const charCode = e.keyCode;
            if (
                charCode > 31 &&
                (charCode < 48 || charCode > 57) &&
                charCode !== 46 &&
                charCode !== 190 &&
                ![8, 37, 39].includes(charCode)
            ) {
                e.preventDefault();
            } else if (charCode === 190 ? this.inputFields.puppyPrice.indexOf(".") > -1 : false) {
                e.preventDefault();
            } else {
                return true;
            }
        },
        calculateOnMobile() {
            this.calculateRepayments()
            // Close keyboard when using mobile
            setTimeout(() =>{
                this.$refs.priceInput.blur()
            }, 500); 
        }
    },
};
